export const GRADE_KEY = 'grade'
export const AVATAR_KEY = 'avatar'
export const HAS_SEEN_TUTORIAL_ON_THE_FIRST_LOGIN =
  'HAS_SEEN_TUTORIAL_ON_THE_FIRST_LOGIN'
